import request from './index'
import {
  LoginRequest,
  LoginResponse,
  RegisterRequest,
  UserInfo,
  UpdateUserInfoRequest,
  ChangePasswordRequest,
  GenerateInviteCodeRequest,
} from '../types'

export const userApi = {
  login: (data: LoginRequest) =>
    request.post<LoginResponse>('/user/login', data),

  register: (data: RegisterRequest) =>
    request.post<UserInfo>('/user/register', data),

  getUserInfo: () =>
    request.get<UserInfo>('/user/info'),

  updateUserInfo: (data: UpdateUserInfoRequest) =>
    request.put<UserInfo>('/user/info', data),

  changePassword: (data: ChangePasswordRequest) =>
    request.put<boolean>('/user/password', data),

  generateInviteCode: (data: GenerateInviteCodeRequest) =>
    request.post<string>('/invite-code/generate', data),

  getInviteCodeList: () =>
    request.get<Array<{ id: number; code: string; role: string; createTime: string; useCount: number }>>('/invite-code/list'),
}
